"use client"

import React from "react"
import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import { ConsultantFilters } from "@/app/types"
import { SearchConsultantForm } from "./find-consultant-form"
import HeroCarousel from "../Carousel/HeroCarousel"

interface FindConsultantHeroProps {
  onSubmit: (filters: ConsultantFilters) => void
  defaultFilters?: ConsultantFilters
}

export const FindConsultantHero = ({
  onSubmit,
  defaultFilters = {},
  translations
}: FindConsultantHeroProps & { translations: Record<string, any> }) => {

  const promoSlides = [
    'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80', // Diverse business team in meeting
    'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80', // Female engineer working
    'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80', // Male nurse with patient
    'https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80', // Diverse group of students
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80', // Marketer analyzing social media
    'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80'
  ]

  const renderSlide = (slide: string, index: number) => (
    <div
      key={index}
      className="relative w-full h-[580px] lg:h-[450px]"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${slide})` }}
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-gray-950/80 to-gray-800/80" />
    </div>
  );

  return (
    <section className="relative w-full">
      <HeroCarousel
        slides={promoSlides}
        renderSlide={renderSlide}
        contentPosition="static-overlay"
        staticContent={
          <div className="mx-auto grid max-w-screen-2xl">
            <div className="container duration-500 md:py-16 py-10">
              <div className="px-6 md:text-left">
                <div className="max-w-screen-md flex-1 break-words md:break-keep">
                  <HeadingText className="max-w-md font-sans text-white" level={1}>
                    {translations.consultants.title}
                  </HeadingText>
                  <SearchConsultantForm
                    translations={translations.consultants}
                    onSubmit={onSubmit}
                    defaultFilters={defaultFilters}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        autoPlay={true}
        interval={3000}
      />
    </section>
  )
}